import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NavMenuService } from '../../../../../core/components/navmenu/navmenu.service';
import { PeriodoPlazoService } from '../plazos.service';
import { DatosPeriodoViewModel, PlazoPeriodoCamViewModel } from '../plazos.types';
import { EnumSiNo } from '../../../../../core/_infrastructure/types/common';
import { PeriodoCamService } from '../../datosbasicos/periodocam.service';

@Component({
    selector: 'app-plazos-wrapper-edit',
    templateUrl: './plazos-wrapper-edit.component.html',
})
export class PlazosWrapperEditComponent extends ComponentBase implements OnInit {
    /**
     * @article: Reactive forms with smart dumb components
     * https://medium.com/angular-athens/reactive-forms-with-smart-dumb-components-48ebc81417c7
     */

    visibilitySpinner = false;
    plazoPeriodo: PlazoPeriodoCamViewModel;
    datosPeriodo: DatosPeriodoViewModel;
    IdPeriodo: any;

    Parcela: boolean;
    Confeccion: boolean;
    Invernadero: boolean;
    EmpresaDeshidratadora: boolean;

    PresentarSolicitudesFueraPeriodo: boolean;
    FechaInicioPeriodo: Date;
    FechaFinPeriodo: Date;

    fechaParcelaOblig = false;
    fechaConfeccionOblig = false;
    fechaInvernaderoOblig = false;
    fechaEmpDeshidratadoraOblig = false;

    successMessage = 'Plazo guardado correctamente';
    listUrl = '/mantenimiento/periodos/plazos/';

    esVigenteConSolicitudes = false;
    private habilitadaExportacionFields = [
        'HabilitadaExportacionParcelas',
        'HabilitadaExportacionAlmacenes',
        'HabilitadaExportacionInvernaderos',
        'HabilitadaExportacionEmpDeshidratadoras',
        'FechaInicioExportacionParcela',
        'FechaInicioExportacionConfeccion',
        'FechaInicioExportacionInvernadero',
        'FechaInicioExportacionEmpDeshidratadoras',
    ];

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const IdPeriodo = params.get('id');
        if (IdPeriodo) {
            this.IdPeriodo = parseInt(IdPeriodo);
        }

        const id: any = params.get('idplazo');
        if (id) {
            // Venimos por plazos/:id/edit/:idplazo
            this.getPlazoPeriodo(id);
        } else {
            // Venimos por plazos/:id/create
            this.getDatosPeriodo(this.IdPeriodo);
        }
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private plazosService: PeriodoPlazoService,
        private periodoCamService: PeriodoCamService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.form = this.fb.group({
            Id: [0],
            IdPeriodo: [0],
            FechaInicioPeriodo: [{ value: null, disabled: true }],
            FechaFinPeriodo: [{ value: null, disabled: true }],
            PresentarSolicitudesFueraPeriodo: [{ value: false, disabled: true }],
            FechaInicioPresentacion: [null, Validators.required],
            FechaFinPresentacion: [null, Validators.required],
            FechaInicioExportacionParcela: [null],
            FechaInicioExportacionConfeccion: [null],
            FechaInicioExportacionInvernadero: [null],
            FechaInicioExportacionEmpDeshidratadoras: [null],
            Parcela: [{ value: false, disabled: true }],
            Confeccion: [{ value: false, disabled: true }],
            Invernadero: [{ value: false, disabled: true }],
            EmpresaDeshidratadora: [{ value: false, disabled: true }],
            PresentacionAutoParcela: [false],
            PresentacionAutoAlmacenes: [false],
            PresentacionAutoInvernadero: [false],
            PresentacionAutoEmpDeshidratadoras: [false],
            ObligatoriaPrimeraInspeccion: [false],
            HabilitadaExportacionAlmacenes: [false],
            HabilitadaExportacionEmpDeshidratadoras: [false],
            HabilitadaExportacionInvernaderos: [false],
            HabilitadaExportacionParcelas: [false],
        });
    }

    /**
     * Método que invoca a la API para cargar los datos de un periodo (Tipos) a partir de su id.
     * @param id number
     * @return void
     */
    private getDatosPeriodo(id: number): void {
        this.plazosService
            .getDatosPeriodo(id)
            .pipe(
                tap((d: DatosPeriodoViewModel) => {
                    this.datosPeriodo = d;
                    this.plazosService.datosPeriodo = this.datosPeriodo;
                    this.navMenuService.updateMenuServiceForPeriodo(d.IdPeriodo!);
                    this.form.patchValue({
                        IdPeriodo: this.datosPeriodo?.IdPeriodo,
                        FechaInicioPeriodo: this.datosPeriodo?.FechaInicioPeriodo ? new Date(this.datosPeriodo?.FechaInicioPeriodo) : null,
                        FechaFinPeriodo: this.datosPeriodo?.FechaFinPeriodo ? new Date(this.datosPeriodo?.FechaFinPeriodo) : null,
                        PresentarSolicitudesFueraPeriodo: this.datosPeriodo?.PresentarSolicitudesFueraPeriodo || false,
                        Parcela: this.datosPeriodo?.Parcela,
                        Confeccion: this.datosPeriodo?.Confeccion,
                        Invernadero: this.datosPeriodo?.Invernadero,
                        EmpresaDeshidratadora: this.datosPeriodo?.EmpresaDeshidratadora,
                    });
                    this.Parcela = this.datosPeriodo?.Parcela;
                    this.Confeccion = this.datosPeriodo?.Confeccion;
                    this.Invernadero = this.datosPeriodo?.Invernadero;
                    this.EmpresaDeshidratadora = this.datosPeriodo?.EmpresaDeshidratadora;
                    this.FechaInicioPeriodo = new Date(this.datosPeriodo?.FechaInicioPeriodo);
                    this.FechaFinPeriodo = new Date(this.datosPeriodo?.FechaFinPeriodo);
                    this.PresentarSolicitudesFueraPeriodo = this.datosPeriodo?.PresentarSolicitudesFueraPeriodo;
                    this.manageDisableFormControls();

                    if (this.esPeriodoPlazoIniciado && !this.esPeriodoPlazoFinalizado) {
                        this.form.disable();
                        return;
                    }
                    // this.getSiVigenteConSolicitudes(this.IdPeriodo);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.form.disable();
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Método que invoca a la API para cargar los datos de un plazo a partir de su id.
     * @param id number
     * @return void
     */
    private getPlazoPeriodo(id: number): void {
        this.plazosService
            .getPlazoPeriodo(id)
            .pipe(
                tap((p: PlazoPeriodoCamViewModel) => {
                    this.plazoPeriodo = p;
                    this.plazosService.plazoPeriodo = this.plazoPeriodo;
                    this.navMenuService.updateMenuServiceForPeriodo(p.IdPeriodo!);
                    this.Parcela = this.plazoPeriodo?.Parcela;
                    this.Confeccion = this.plazoPeriodo?.Confeccion;
                    this.Invernadero = this.plazoPeriodo?.Invernadero;
                    this.EmpresaDeshidratadora = this.plazoPeriodo?.EmpresaDeshidratadora;

                    this.FechaInicioPeriodo = new Date(this.plazoPeriodo?.FechaInicioPeriodo);
                    this.FechaFinPeriodo = new Date(this.plazoPeriodo?.FechaFinPeriodo);
                    this.PresentarSolicitudesFueraPeriodo = this.plazoPeriodo?.PresentarSolicitudesFueraPeriodo;
                    this.manageDisableFormControls();
                    this.getSiVigenteConSolicitudes(this.IdPeriodo);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.form.disable();
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Método que invoca a la API para comprueba si el periodo es vigente y tiene solicitudes de campaña asociadas.
     * @param id number
     * @return void
     */
    private getSiVigenteConSolicitudes(id: number): void {
        this.periodoCamService
            .getPeriodoEsVigente(id)
            .pipe(
                tap((p: boolean) => {
                    this.esVigenteConSolicitudes = p;
                    if (this.esVigenteConSolicitudes) {
                        this.disableControlsSiVigente();
                    } else {
                        if (this.esPeriodoPlazoIniciado && !this.esPeriodoPlazoFinalizado) {
                            this.form.disable();
                            return;
                        }
                    }
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Cuando el periodo de presentación ya ha empezado, no dejamos modificar algunos campos.
     */
    private disableControlsSiVigente(): void {
        for (const fieldName in this.form.controls) {
            if (fieldName === 'FechaInicioPresentacion' || fieldName === 'FechaFinPresentacion') {
                if (!this.esPeriodoPlazoIniciado || this.esPeriodoPlazoFinalizado) {
                    return;
                }
            }

            if (this.habilitadaExportacionFields.indexOf(fieldName) === -1) {
                const control = this.form.get(fieldName) as FormControl; // This gets the actual formControl.
                control.disable();
            }
        }
    }

    /**
     * Se controla la obligatoriedad o no de los controles en el formulario, relacionados con
     * la habilitación de exportación o no, para cada tipo de recinto (o solicitud)
     */
    private manageDisableFormControls() {
        this.disableControlsParcela();
        this.disableControlsAlmacen();
        this.disableControlsInvernadero();
        this.disableControlsEmpDeshidratadora();
        if (!this.Invernadero && !this.Parcela) {
            this.form.controls['ObligatoriaPrimeraInspeccion'].disable();
        }
    }

    private disableControlsParcela(): void {
        if (!this.Parcela) {
            this.fechaParcelaOblig = false;
            this.form.controls['FechaInicioExportacionParcela'].disable();
            this.removeValidators('FechaInicioExportacionParcela');
            this.form.controls['PresentacionAutoParcela'].disable();
            this.form.controls['HabilitadaExportacionParcelas'].disable();
            return;
        }
        if (this.form?.controls['HabilitadaExportacionParcelas'].value) {
            this.fechaParcelaOblig = true;
            this.form.controls['FechaInicioExportacionParcela'].addValidators(Validators.required);
        } else {
            this.fechaParcelaOblig = false;
            this.form.patchValue({
                FechaInicioExportacionParcela: '',
            });
            this.removeValidators('FechaInicioExportacionParcela');
        }
    }

    private disableControlsAlmacen(): void {
        if (!this.Confeccion) {
            this.fechaConfeccionOblig = false;
            this.form.controls['FechaInicioExportacionConfeccion'].disable();
            this.removeValidators('FechaInicioExportacionConfeccion');
            this.form.controls['PresentacionAutoAlmacenes'].disable();
            this.form.controls['HabilitadaExportacionAlmacenes'].disable();
            return;
        }
        if (this.form?.controls['HabilitadaExportacionAlmacenes'].value) {
            this.fechaConfeccionOblig = true;
            this.form.controls['FechaInicioExportacionConfeccion'].addValidators(Validators.required);
        } else {
            this.fechaConfeccionOblig = false;
            this.form.patchValue({
                FechaInicioExportacionConfeccion: '',
            });
            this.removeValidators('FechaInicioExportacionConfeccion');
        }
    }

    private disableControlsInvernadero(): void {
        if (!this.Invernadero) {
            this.fechaInvernaderoOblig = false;
            this.form.controls['FechaInicioExportacionInvernadero'].disable();
            this.removeValidators('FechaInicioExportacionInvernadero');
            this.form.controls['PresentacionAutoInvernadero'].disable();
            this.form.controls['HabilitadaExportacionInvernaderos'].disable();
            return;
        }
        if (this.form?.controls['HabilitadaExportacionInvernaderos'].value) {
            this.fechaInvernaderoOblig = true;
            this.form.controls['FechaInicioExportacionInvernadero'].addValidators(Validators.required);
        } else {
            this.fechaInvernaderoOblig = false;
            this.form.patchValue({
                FechaInicioExportacionInvernadero: '',
            });
            this.removeValidators('FechaInicioExportacionInvernadero');
        }
    }

    private disableControlsEmpDeshidratadora(): void {
        if (!this.EmpresaDeshidratadora) {
            this.fechaEmpDeshidratadoraOblig = false;
            this.form.controls['FechaInicioExportacionEmpDeshidratadoras'].disable();
            this.removeValidators('FechaInicioExportacionEmpDeshidratadoras');
            this.form.controls['PresentacionAutoEmpDeshidratadoras'].disable();
            this.form.controls['HabilitadaExportacionEmpDeshidratadoras'].disable();
            return;
        }
        if (this.form?.controls['HabilitadaExportacionEmpDeshidratadoras'].value) {
            this.fechaEmpDeshidratadoraOblig = true;
            this.form.controls['FechaInicioExportacionEmpDeshidratadoras'].addValidators(Validators.required);
        } else {
            this.fechaEmpDeshidratadoraOblig = false;
            this.form.patchValue({
                FechaInicioExportacionEmpDeshidratadoras: '',
            });
            this.removeValidators('FechaInicioExportacionEmpDeshidratadoras');
        }
    }

    /**
     * Invocación de la API para salvar los cambios realizados en el periodo
     * @return void
     */
    onSave(): void {
        const model = this.form.getRawValue();

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos del Plazo antes de guardar');
            return;
        }

        if (this.form.value.FechaInicioPresentacion > this.form.value.FechaFinPresentacion) {
            this.addErrorMessage('La Fecha Inicio Presentación no puede ser posterior a la Fecha Fin Presentación');
            return;
        }
        if (this.form.value.FechaInicioPresentacion < this.FechaInicioPeriodo) {
            this.addErrorMessage('La Fecha Inicio Presentación no puede ser anterior a la Fecha Inicio del Periodo');
            return;
        }
        if (this.form.value.FechaInicioPresentacion > this.FechaFinPeriodo) {
            this.addErrorMessage('La Fecha Inicio Presentación no puede ser posterior a la Fecha Fin del Periodo');
            return;
        }
        if (this.form.value.FechaFinPresentacion < this.FechaInicioPeriodo) {
            this.addErrorMessage('La Fecha Fin Presentación no puede ser anterior a la Fecha Inicio del Periodo');
            return;
        }
        if (this.form.value.FechaFinPresentacion > this.FechaFinPeriodo && !this.PresentarSolicitudesFueraPeriodo) {
            this.addErrorMessage('La Fecha Fin Presentación no puede ser posterior a la Fecha Fin del Periodo');
            return;
        }

        if (!model.Parcela) {
            model.PresentacionAutoParcela = EnumSiNo.NO;
        }
        if (!model.Confeccion) {
            model.PresentacionAutoAlmacenes = EnumSiNo.NO;
        }
        if (!model.Invernadero) {
            model.PresentacionAutoInvernadero = EnumSiNo.NO;
        }
        if (!model.EmpresaDeshidratadora) {
            model.PresentacionAutoEmpDeshidratadoras = EnumSiNo.NO;
        }

        this.visibilitySpinner = true;

        this.plazosService
            .save(model)
            .pipe(
                tap(() => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.visibilitySpinner = false;
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl + this.IdPeriodo]);
    }

    onChangeHabilitarExportacion(): void {
        this.manageDisableFormControls();
    }

    get formInvalid(): boolean {
        return !this.form.valid || !this.form.dirty || this.form.pristine;
    }

    get esPeriodoPlazoIniciado(): boolean {
        const hoy = new Date();
        let fechaInicioPeriodo;
        if (this.plazoPeriodo && this.plazoPeriodo.FechaInicioPresentacion) {
            fechaInicioPeriodo = new Date(this.plazoPeriodo.FechaInicioPresentacion);
            return hoy >= fechaInicioPeriodo;
        }
        /*
        if (this.datosPeriodo) {
            fechaInicioPeriodo = new Date(this.datosPeriodo?.FechaInicioPeriodo);
            return hoy >= fechaInicioPeriodo;
        }
        */
        return false;
    }

    get esPeriodoPlazoFinalizado(): boolean {
        const hoy = new Date();
        let fechaFinPeriodo;
        if (this.plazoPeriodo && this.plazoPeriodo?.FechaFinPresentacion) {
            fechaFinPeriodo = new Date(this.plazoPeriodo?.FechaFinPresentacion);
            return hoy >= fechaFinPeriodo;
        }
        /*
        if (this.datosPeriodo) {
            fechaFinPeriodo = new Date(this.datosPeriodo?.FechaFinPeriodo);
            return hoy >= fechaFinPeriodo;
        }
        */
        return false;
    }
}
